module.exports = __webpack_public_path__ + "img/regavet.cf367ca6.png";